import { useRouter } from "@core/Api/useRouter";
import { useCatalogPropsStore } from "@core-ui/stores/CatalogPropsStore/CatalogPropsStore.provider";
import OnNetworkApiErrorService from "@ext/errorHandlers/client/OnNetworkApiErrorService";
import type GitStorageData from "@ext/git/core/model/GitStorageData";
import t from "@ext/localization/locale/translate";
import SelectStorageDataForm from "@ext/storage/components/SelectStorageDataForm";
import { getInitStorageData } from "@ext/storage/logic/getInitStorageData";
import { Dialog, DialogContent, DialogTrigger } from "@ui-kit/Dialog";
import { useState } from "react";
import FetchService from "../../../ui-logic/ApiServices/FetchService";
import MimeTypes from "../../../ui-logic/ApiServices/Types/MimeTypes";
import ApiUrlCreatorService from "../../../ui-logic/ContextServices/ApiUrlCreator";

const InitStorage = ({ trigger }: { trigger: JSX.Element }) => {
	const catalogName = useCatalogPropsStore((state) => state.data.name);
	const apiUrlCreator = ApiUrlCreatorService.value;
	const router = useRouter();

	const [isOpen, setIsOpen] = useState(false);

	const onSubmit = async (data: GitStorageData) => {
		const newData = getInitStorageData(data, catalogName);

		const res = await FetchService.fetch(apiUrlCreator.initStorage(), JSON.stringify(newData), MimeTypes.json);
		if (res.ok) void router.pushPath(await res.text());
		setIsOpen(false);
		return res.ok;
	};

	return (
		<Dialog onOpenChange={setIsOpen} open={isOpen}>
			<DialogTrigger asChild>{trigger}</DialogTrigger>
			<DialogContent>
				<OnNetworkApiErrorService.Provider callback={() => setIsOpen(false)}>
					<SelectStorageDataForm mode="init" onSubmit={onSubmit} title={t("connect-storage")} />
				</OnNetworkApiErrorService.Provider>
			</DialogContent>
		</Dialog>
	);
};

export default InitStorage;
